import React from 'react';
import { Button, Col, Form, Row } from 'react-bootstrap';
import { WeekdayCheckInAndCheckOutTimeByDurationItem } from '../../../common/types/rates.types';

function WeekdayCheckInTimesByDurationsForm({
  addCheckInTimeByDurationRule,
  handleCheckInTimeByDurationInputChange,
  checkInTimeByDurationData,
  isExistingCheckInTime,
}: {
  /* TODO Replace any/ CORE-1006 */
  /* eslint-disable  @typescript-eslint/no-explicit-any */
  addCheckInTimeByDurationRule: any;
  /* TODO Replace any/ CORE-1006 */
  /* eslint-disable  @typescript-eslint/no-explicit-any */
  handleCheckInTimeByDurationInputChange: any;
  checkInTimeByDurationData: WeekdayCheckInAndCheckOutTimeByDurationItem;
  isExistingCheckInTime: boolean;
}) {
  if (!isExistingCheckInTime) {
    return null;
  }

  return (
    <>
      <h4 className="h5 mb-24">
        Sisäänkirjautumisen kellonajat varauksen keston mukaan
      </h4>
      <p className="mb-24">
        Kellonaika on voimassa, mikäli varauksen kesto on enintään annettu
        vuorokausimäärä.
      </p>

      <Row xs={1} sm="auto">
        <Col md={3}>
          <Form.Group controlId="lengthOfStay" className="mb-24">
            <Form.Label>Kesto enintään</Form.Label>
            <Form.Control
              type="text"
              name="lengthOfStay"
              onChange={handleCheckInTimeByDurationInputChange}
              value={checkInTimeByDurationData.lengthOfStay || ''}
            />
          </Form.Group>
        </Col>
        <Col md={6} xl={7}>
          <Form.Group controlId="timeOfDay" className="mb-24">
            <Form.Label>Sisäänkirjautumisen kellonaika</Form.Label>
            <Form.Control
              type="text"
              name="timeOfDay"
              onChange={handleCheckInTimeByDurationInputChange}
              value={checkInTimeByDurationData.timeOfDay || ''}
              placeholder="HH:mm"
            />
            <Form.Text muted>
              Anna sisäänkirjautumisen kellonaika muodossa HH:mm (esim. 12:30)
            </Form.Text>
          </Form.Group>
        </Col>
        <Col md={3} xl={2}>
          <div className="mt-32 mb-24">
            <Button variant="blue" onClick={addCheckInTimeByDurationRule}>
              Lisää
            </Button>
          </div>
        </Col>
      </Row>
    </>
  );
}

export default WeekdayCheckInTimesByDurationsForm;
